const $menu = {
  mobileMenuOpened: false,
  toggle: () => {
    $('.mobile-menu__list--has-children').on('click', (e) => {
      if (this.mobileMenuOpened) {
        return true;
      }

      const self = $(e.currentTarget);
      self.find('.mobile-menu__nav-children').slideToggle();
      this.mobileMenuOpened = true;

      return false;
    });
  },
};

const account = {
  handleRememberMe: () => {
    var rememberMeCheckbox = document.getElementById('rememberMeCheckbox');
    if (rememberMeCheckbox.checked) {
      var username = document.getElementById('username').value; // Get username from the form
      // Store username in a cookie or local storage
      localStorage.setItem('rememberedUsername', username);
    } else {
      // Clear any previously stored data
      localStorage.removeItem('rememberedUsername');
    }
  },
};

const $slider = {
  init: () => {
    $slider.banner();
    $slider.testimonial();
  },
  banner: () => {
    new Swiper('.banner-slider__carousel', {
      slidesPerView: 1,
      effect: 'fade', // Add this line
      fadeEffect: { crossFade: true }, // And this line
      speed: 700, // Add this line
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  },
  testimonial: () => {
    new Swiper('.testimonial-slider__carousel', {
      slidesPerView: 3,
      spaceBetween: 10,
      pagination: {
        el: '.testimonial-slider__pagination',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 1,
        },

        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
        },
      },
    });
  },
};

$(document).ready(() => {
  $menu.toggle();
  $slider.init();
});
